import { render, staticRenderFns } from "./TrancheInvest2.vue?vue&type=template&id=6ac8e862&scoped=true&"
import script from "./TrancheInvest2.vue?vue&type=script&lang=js&"
export * from "./TrancheInvest2.vue?vue&type=script&lang=js&"
import style0 from "./TrancheInvest2.vue?vue&type=style&index=0&id=6ac8e862&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac8e862",
  null
  
)

export default component.exports